import { createSlice } from "@reduxjs/toolkit";
import {
  fetchQuizeWithPage,
  deleteQuize,
  bulkDeleteQuize,
  getQuizeWithIDS,
  getQuizeWithFilter,
  createQuize,
  updateQuize,
} from "./thunk";

const initialState = {
  quizzes: {
    data: [],
    count: 0,
  },
  selectedQuize: null,
  loading: false,
  error: null,
  filterParams: {
    currentPage: 1,  // Default value set
    perPage: 20,     // Default value set
  },
};


const quizeSlice = createSlice({
  name: "quize",
  initialState,
  reducers: {
    setFilterParams: (state, action) => {
      state.filterParams = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedQuize: (state) => {
      state.selectedQuize = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // 🔄 FETCH QUIZZES WITH PAGINATION
      .addCase(fetchQuizeWithPage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuizeWithPage.fulfilled, (state, action) => {
        state.loading = false;
        state.quizzes = {
          data: action.payload?.data || [],
          count: action.payload?.count || 0,
        };
      })
      .addCase(fetchQuizeWithPage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch quizzes";
      })

      // 🔍 FETCH QUIZZES WITH FILTERS
      .addCase(getQuizeWithFilter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuizeWithFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.quizzes = {
          data: action.payload?.data || [],
          count: action.payload?.count || 0,
        };
      })
      .addCase(getQuizeWithFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to filter quizzes";
      })

      // ➕ CREATE QUIZ
          // ➕ CREATE QUIZ
          .addCase(createQuize.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(createQuize.fulfilled, (state, action) => {
            state.loading = false;
            const newQuiz = action.payload?.data;
    
            // Ensure it's an array
            if (Array.isArray(state.quizzes.data)) {
              state.quizzes.data = [...state.quizzes.data, newQuiz];
            } else {
              state.quizzes.data = [newQuiz];
            }
          })
          .addCase(createQuize.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message || "Failed to create quiz";
          })
    
          // ✏️ UPDATE QUIZ
          .addCase(updateQuize.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(updateQuize.fulfilled, (state, action) => {
            state.loading = false;
            const updatedQuiz = action.payload?.data;
    
            if (updatedQuiz && Array.isArray(state.quizzes.data)) {
              const index = state.quizzes.data.findIndex((q) => q.id === updatedQuiz.id);
              if (index !== -1) {
                state.quizzes.data[index] = updatedQuiz;
              }
            }
          })
          .addCase(updateQuize.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message || "Failed to update quiz";
          })
    
      // ❓ FETCH SINGLE QUIZ BY ID
      .addCase(getQuizeWithIDS.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuizeWithIDS.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedQuize = action.payload?.data || null;
      })
      .addCase(getQuizeWithIDS.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch quiz by ID";
      })

      // ❌ DELETE QUIZ
      .addCase(deleteQuize.fulfilled, (state, action) => {
        const deletedId = action.payload?.id;
        if (deletedId) {
          state.quizzes.data = state.quizzes.data.filter(
            (quiz) => quiz.id !== deletedId
          );
        }
      })

      // 🗑 BULK DELETE QUIZZES
      .addCase(bulkDeleteQuize.fulfilled, (state, action) => {
        const deletedIds = action.payload;
        state.quizzes.data = state.quizzes.data.filter(
          (quiz) => !deletedIds.includes(quiz.id)
        );
      });
  },
});

export const {
  setFilterParams,
  clearError,
  clearSelectedQuize,
} = quizeSlice.actions;

export default quizeSlice.reducer;
